import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';

import { IntraOne_ds_get_licenseplate_by_lookupcode_warehousenameService } from './IntraOne.datasource.index';
import { IntraOne_ds_get_location_by_warehouse_locationService } from './IntraOne.datasource.index';
import { IntraOne_ds_get_loose_licenseplate_by_location_nameService } from './IntraOne.datasource.index';
import { IntraOne_ds_get_pick_tasks_by_shipping_container_idService } from './IntraOne.datasource.index';
import { IntraOne_ds_get_primary_pick_location_by_material_id_packaging_idService } from './IntraOne.datasource.index';
import { IntraOne_ds_get_primary_pick_location_by_material_id_packaging_id_flowService } from './IntraOne.datasource.index';
import { IntraOne_ds_get_shipment_details_by_shipping_container_idService } from './IntraOne.datasource.index';
import { IntraOne_ds_get_shipment_details_by_task_idService } from './IntraOne.datasource.index';
import { IntraOne_ds_get_task_by_idService } from './IntraOne.datasource.index';

@Injectable({ providedIn: 'root' })
export class IntraOne_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
  public IntraOne: IntraOne_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_get_licenseplate_by_lookupcode_warehousename: IntraOne_ds_get_licenseplate_by_lookupcode_warehousenameService;
  public get ds_get_licenseplate_by_lookupcode_warehousename(): IntraOne_ds_get_licenseplate_by_lookupcode_warehousenameService {
    if(!this._ds_get_licenseplate_by_lookupcode_warehousename) {
      this._ds_get_licenseplate_by_lookupcode_warehousename = this.injector.get(IntraOne_ds_get_licenseplate_by_lookupcode_warehousenameService);
    }
    return this._ds_get_licenseplate_by_lookupcode_warehousename;
  }
  private _ds_get_location_by_warehouse_location: IntraOne_ds_get_location_by_warehouse_locationService;
  public get ds_get_location_by_warehouse_location(): IntraOne_ds_get_location_by_warehouse_locationService {
    if(!this._ds_get_location_by_warehouse_location) {
      this._ds_get_location_by_warehouse_location = this.injector.get(IntraOne_ds_get_location_by_warehouse_locationService);
    }
    return this._ds_get_location_by_warehouse_location;
  }
  private _ds_get_loose_licenseplate_by_location_name: IntraOne_ds_get_loose_licenseplate_by_location_nameService;
  public get ds_get_loose_licenseplate_by_location_name(): IntraOne_ds_get_loose_licenseplate_by_location_nameService {
    if(!this._ds_get_loose_licenseplate_by_location_name) {
      this._ds_get_loose_licenseplate_by_location_name = this.injector.get(IntraOne_ds_get_loose_licenseplate_by_location_nameService);
    }
    return this._ds_get_loose_licenseplate_by_location_name;
  }
  private _ds_get_pick_tasks_by_shipping_container_id: IntraOne_ds_get_pick_tasks_by_shipping_container_idService;
  public get ds_get_pick_tasks_by_shipping_container_id(): IntraOne_ds_get_pick_tasks_by_shipping_container_idService {
    if(!this._ds_get_pick_tasks_by_shipping_container_id) {
      this._ds_get_pick_tasks_by_shipping_container_id = this.injector.get(IntraOne_ds_get_pick_tasks_by_shipping_container_idService);
    }
    return this._ds_get_pick_tasks_by_shipping_container_id;
  }
  private _ds_get_primary_pick_location_by_material_id_packaging_id: IntraOne_ds_get_primary_pick_location_by_material_id_packaging_idService;
  public get ds_get_primary_pick_location_by_material_id_packaging_id(): IntraOne_ds_get_primary_pick_location_by_material_id_packaging_idService {
    if(!this._ds_get_primary_pick_location_by_material_id_packaging_id) {
      this._ds_get_primary_pick_location_by_material_id_packaging_id = this.injector.get(IntraOne_ds_get_primary_pick_location_by_material_id_packaging_idService);
    }
    return this._ds_get_primary_pick_location_by_material_id_packaging_id;
  }
  private _ds_get_primary_pick_location_by_material_id_packaging_id_flow: IntraOne_ds_get_primary_pick_location_by_material_id_packaging_id_flowService;
  public get ds_get_primary_pick_location_by_material_id_packaging_id_flow(): IntraOne_ds_get_primary_pick_location_by_material_id_packaging_id_flowService {
    if(!this._ds_get_primary_pick_location_by_material_id_packaging_id_flow) {
      this._ds_get_primary_pick_location_by_material_id_packaging_id_flow = this.injector.get(IntraOne_ds_get_primary_pick_location_by_material_id_packaging_id_flowService);
    }
    return this._ds_get_primary_pick_location_by_material_id_packaging_id_flow;
  }
  private _ds_get_shipment_details_by_shipping_container_id: IntraOne_ds_get_shipment_details_by_shipping_container_idService;
  public get ds_get_shipment_details_by_shipping_container_id(): IntraOne_ds_get_shipment_details_by_shipping_container_idService {
    if(!this._ds_get_shipment_details_by_shipping_container_id) {
      this._ds_get_shipment_details_by_shipping_container_id = this.injector.get(IntraOne_ds_get_shipment_details_by_shipping_container_idService);
    }
    return this._ds_get_shipment_details_by_shipping_container_id;
  }
  private _ds_get_shipment_details_by_task_id: IntraOne_ds_get_shipment_details_by_task_idService;
  public get ds_get_shipment_details_by_task_id(): IntraOne_ds_get_shipment_details_by_task_idService {
    if(!this._ds_get_shipment_details_by_task_id) {
      this._ds_get_shipment_details_by_task_id = this.injector.get(IntraOne_ds_get_shipment_details_by_task_idService);
    }
    return this._ds_get_shipment_details_by_task_id;
  }
  private _ds_get_task_by_id: IntraOne_ds_get_task_by_idService;
  public get ds_get_task_by_id(): IntraOne_ds_get_task_by_idService {
    if(!this._ds_get_task_by_id) {
      this._ds_get_task_by_id = this.injector.get(IntraOne_ds_get_task_by_idService);
    }
    return this._ds_get_task_by_id;
  }
}

